module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/special_offer_image-e282c79e334b4a45bedd046702c2a075.png";